export const FLOW_NAME = "network-performance-analysis";
export type FLOW_TYPE = "network-performance-analysis";

export const FAILURE_CHANCES_RECIPE = "telecom-network-performance-prediction";
export const FAILURE_MODE_RECIPE = "profilecluster-rows";

export const PERFORMANCE_DATA = "perf";
export const LOCATION_DATA = "site";
export const AUGMENTED_DATA = "perf-with-future-cssr";
export const CONSOLIDATED_DATA = "cons";

export const RUN_ID = "RUN_ID";
export const INIT_RUN = "INIT_RUN";
export const CREATED_BY = "CREATED_BY";
export const TIME_STAMP = "TIME_STAMP";

export const TARGET_Y_KEY = "target-performance-key";
export const TIME_COLUMN_KEY = "time-column-key";
export const CELL_KEY = "cell-column-key";
export const SITE_KEY = "site-column-key";
export const SITE_DATA_CELL_KEY = "cell-in-site-data-key";
export const SITE_DATA_LAT_KEY = "latitude-key";
export const SITE_DATA_LONG_KEY = "longitude-key";

export const TIME_COLUMN = "Time";
export const PERF_CELL_NAME = "Cell Name";
export const CSSR = "CS CSSR (with SDCCH blocks)";

export const VARIABLE_MAPPING = {
  [TIME_COLUMN_KEY]: [TIME_COLUMN],
  [CELL_KEY]: ["Cell Name"],
  [SITE_DATA_CELL_KEY]: ["cellName"],
  [SITE_DATA_LAT_KEY]: ["Latitude"],
  [SITE_DATA_LONG_KEY]: ["Longitude"],
};

export const THRESHOLD_KEY = "threshold";
export const LOOKAHEAD_KEY = "look-ahead";
export const DEFAULT_LOOKAHEAD = 3;

export const THRESHOLD = 99.99;

export const THRESHOLD_FILTER = [
  { column: CSSR, operator: "gt", range: [THRESHOLD], condition: "include" },
];

export const DEFAULT_MODEL_PARAMS = {
  [THRESHOLD_KEY]: THRESHOLD_FILTER,
  [LOOKAHEAD_KEY]: DEFAULT_LOOKAHEAD,
};

export const DEFAULT_MODELS_KEY = "default-models";
export const CLUSTER_NAMES_KEY = "cluster-names";
